import { Box, Stack, styled, Typography } from '@mui/material';

export const ContainerProductsDetails = styled(Stack)(({ theme }) => ({
  width: '90%',
  marginTop: '48px',
  borderRadius: '16px',
  position: 'relative',
  marginInline: 'auto',
  isolation: 'isolate',
  marginBottom: '4rem',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));
export const TopSectionProducts = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: 'auto',
  gap: '20px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    minHeight: 'auto',
  },
}));
export const CardExpectedReturn = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  flexDirection: 'row',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '90px',
  isolation: 'isolate',
  padding: '12px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
}));
export const TypographyTitleExpected = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.primary.main,
  marginLeft: '0px',

  [theme.breakpoints.up('sm')]: {
    marginLeft: '16px',
  },
  [theme.breakpoints.up('lg')]: {
    marginLeft: '26px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
}));
export const TypographyValueExpected = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.h4.fontWeight,
  marginRight: '0px',

  [theme.breakpoints.up('sm')]: {
    marginRight: '26px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));
export const RentabilidadUltimo = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.h4.fontWeight,
  marginRight: '0px',

  [theme.breakpoints.up('sm')]: {
    marginRight: '26px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));
export const BtnGroupContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  isolation: 'isolate',
  flexDirection: 'column',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
  minHeight: 'auto',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: 'auto',
  },
}));
export const ButtonsWrapperStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  height: '82px',
  flex: '1 1 auto',
  [theme.breakpoints.up('md')]: {
    maxWidth: '1380px',
    alignItems: 'center',
  },
}));
export const BtnGroupFunds = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  width: '100%',
  margin: '0px',
  minHeight: 'auto',
  [theme.breakpoints.down('md')]: {
    minHeight: 'auto',
  },
}));
export const BtnGroup = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 0px 8px rgba(61, 64, 75, 0.15)',
  borderRadius: '8px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '12px',
  boxSizing: 'border-box',
  width: '100%',
  margin: '0px',
}));
export const BtnContainer = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  justifyContent: 'center',
  borderRadius: '8px',
  alignItems: 'center',
  padding: '16px',
  boxSizing: 'border-box',
  margin: '0px',
  width: '100%',
  height: 'auto',
});
export const CardsContentDocumentacion = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 0px 8px rgba(61, 64, 75, 0.15)',
  borderRadius: '16px',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  minWidth: '310px',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
  overflow: 'hidden',
  minHeight: '188px',
  width: '100%',
}));
export const HeaderComponent = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  isolation: 'isolate',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '8px 16px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '0px',
  height: '80px',
  width: '100%',
  flexDirection: 'column',
}));
export const TitleCardsDocumentation = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  color: theme.palette.white.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.h1.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  lineHeight: '105%',
  textTransform: 'none',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));
export const BodyComponent = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  minHeight: '104px',
  margin: '8px 0px 0px 0px',
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: '10px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '10px',
  },
}));
export const TitleDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.titleText.fontWeight,
  marginBottom: theme.spacing(1),
}));
export const ChartSection = styled(Stack)(({ theme }) => ({
  flex: '1 0.5 auto',
  width: '100%',
  borderRadius: '8px',
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'block',
  },
}));
export const ConditionsSection = styled(Stack)(({ theme }) => ({
  flex: '1 1 auto',
  backgroundColor: theme.palette.white.main,
  width: '100%',
  minHeight: 0,
  minWidth: '100%',
  [theme.breakpoints.up('md')]: {
    minHeight: '551px',
    minWidth: '400px',
  },
}));
export const ProductDetailContent = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));
export const BtnGroupWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: '20px',
  paddingBottom: '20px',
  [theme.breakpoints.up('md')]: {
    paddingTop: '40px',
    paddingBottom: '40px',
  },
}));
export const RiskWarningBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
export const RiskWarningTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.red.main,
  marginLeft: '10px',
}));
export const InvestmentContentContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));
export const ChartWrapper = styled(Stack)(({ theme }) => ({
  flex: '1 0.5 auto',
  width: '100%',
  borderRadius: '8px',
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
}));
export const InvestmentActionContainer = styled(Stack)(({ theme }) => ({
  flex: '1 1 auto',
  backgroundColor: theme.palette.white.main,
  flexDirection: 'column',
  width: '100%',
  minWidth: '100%',
  [theme.breakpoints.up('md')]: {
    minWidth: '400px',
  },
}));

export const CardContainerMovements = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '32px',
  boxSizing: 'border-box',
  width: '100%',
}));
